<template>
	<v-btn
		icon
		class="ml-1"
		:height="28"
		:width="28"
		v-on:click="showAttributeEditForm"
	>
		<v-icon title="Redaguoti" size="20">mdi-pencil</v-icon>
	</v-btn>
</template>

<script>
	export default {
		methods: {
			showAttributeEditForm: function(){
				this.$vBus.$emit("show-attribute-edit-form", this.e);
			}
		},
		props: {
			e: Object
		}
	};
</script>

<style scoped>

</style>